import {
  RegularBenefitVariant,
  ShippingApplyTo,
} from '../../../../../../../typings'

export const EMPTY_PERCENTUAL_SHIPPING = {
  type: RegularBenefitVariant.PercentualShipping as const,
  value: undefined,
  applyTo: ShippingApplyTo.all,
}
